export default function checkIsSubRoute(currentPath: string, parentPath: string): boolean {
  const cleanCurrent = currentPath.split(/[?#]/)[0]?.replace(/\/+$/, '');
  const cleanParent = parentPath.replace(/\/+$/, '');

  if (cleanCurrent === cleanParent) return false;

  const parentSegments = cleanParent.split('/').filter(Boolean);
  const currentSegments = cleanCurrent?.split('/').filter(Boolean);

  if (!currentSegments?.length) return false;

  if (currentSegments.length <= parentSegments.length) return false;

  return parentSegments.every((seg, idx) => seg === currentSegments[idx]);
}
